// src/app/equipment-grid/equipment-grid.component.ts
import { Component, OnInit } from '@angular/core';

import { Equipment } from '../objects/Equipment';
import { EquipmentService } from '../Services/equipment.services'
import { Router } from '@angular/router';

@Component({
  selector: 'app-equipment-grid',
  templateUrl: './equipment-grid.component.html',
  styleUrls: ['./equipment-grid.component.css'],
})
export class EquipmentGridComponent implements OnInit {
  equipment: Equipment[] = []; 
  isMobile?: boolean;

  constructor(private equipmentService: EquipmentService,public router: Router) {}

  ngOnInit() {
    this.checkisMobile()
    this.loadEquipment();
  }

  loadEquipment() {
    this.equipmentService.getEquipment().subscribe((equipment) => {
      this.equipment = equipment;
    });
  }
 

  checkisMobile() { 
     
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
    if(width < 768)
    {this.isMobile = true;
    }
      else
    {this.isMobile = false;}
    
    
  }
    
    editEquipment(equipment: Equipment) {
    // Implement the edit functionality here
    // You can open a dialog or navigate to a separate edit page with the material's data
    
    this.router.navigate(['equipment/edit', equipment.id]);
      // Implement the edit functionality here
      // You can open a dialog or navigate to a separate edit page with the material's data
   
    console.log('Editing equipment:', equipment);
  }
 
}
